const redux = require("redux");
const thunk = require("redux-thunk").default; 

const DefaultState = require("./DefaultState.js");

const ModeReducers = require("./reducers/ModeReducers.js");
const FileSelectionReducers = require("./reducers/FileSelectionReducers.js");
const FileTypeReducers = require("./reducers/FileTypeReducers.js");
const ValidExtensionReducers = require("./reducers/ValidExtensionReducers.js");
const FileUploadReducers = require("./reducers/FileUploadReducers.js");
const UploadHistoryReducers = require("./reducers/UploadHistoryReducers.js");
const AuthenticationReducers = require("./reducers/AuthenticationReducers.js");

// Metadata
const NexusDataReducers = require("./reducers/metadata/NexusDataReducers.js");
const SmartBonusReducers = require("./reducers/metadata/SmartBonusReducers.js");
const PCardReducers = require("./reducers/metadata/PCardReducers");
const CauditReducers = require("./reducers/metadata/CauditReducers.js");

const reducers = Object.assign({},
    ModeReducers,
    FileSelectionReducers,
    FileTypeReducers,
    ValidExtensionReducers,
    FileUploadReducers,
    UploadHistoryReducers,
    NexusDataReducers,
    SmartBonusReducers,
    PCardReducers,
    CauditReducers);

function reduce(state, action) {
    state = state || DefaultState;

    if (reducers.hasOwnProperty(action.type)) {
        var newState = reducers[action.type](state, action);

        return newState;
    }

    return state;
};

let createStore = redux.applyMiddleware(thunk)(redux.createStore);

const store = createStore(reduce);

module.exports = store;


// WEBPACK FOOTER //
// ./src/store.js